import React, { useEffect, useState } from 'react';
import { Form, Button, Input, Collapse } from 'antd';
import { Card, CardBody, Row, Col } from 'reactstrap';
import {
    SaveOutlined
} from '@ant-design/icons';


const { Panel } = Collapse;

const PowerBiRender = (props) => {
    
    const [getErrorFlag, setErrorFlag] = useState(false);
    const [formPowerBI] = Form.useForm();

    useEffect(() => {
        let widgetData = props.widgetItem !== null &&
            props.widgetItem !== undefined &&
            props.widgetItem.widgetData !== null &&
            props.widgetItem.widgetData.length > 0 &&
            props.widgetItem.widgetData[0];
        if (widgetData.hasOwnProperty("bind")) {
            formPowerBI.setFieldsValue({
                embedUrl: widgetData.embedUrl,
                powerBIToken: widgetData.powerBIToken,
                powerBIId: widgetData.powerBIId
            })
        } else {
            formPowerBI.setFieldsValue({
                embedUrl: "",
                powerBIToken: "",
                powerBIId: ""
            })
        }
    }, [props]);



    const onFinish = () => {
        let forms = formPowerBI.getFieldValue();
        forms["isValid"] = true;
        forms["widgetType"] = "PowerBI";
        props._getLayoutData(props.widgetId, forms);
    }

    return <Collapse accordion bordered={true} className="mt-3" defaultActiveKey={['1']}>
        <Panel header={"PowerBI"} key="1">
            <code><span className='pl-1 font16 font-weight-bold'>PowerBI Property</span></code>
            <Card className="widget-data-card mt-2">
        <CardBody>
            <Form
                form={formPowerBI}
                name="basic"
                onFinish={onFinish}
                autoComplete="off"
                layout="vertical"
            >
                <Row>

                <Form.Item name="embedUrl" className='col pl-1' label={<label
                        className="form-control-label font12"
                    >
                        Embed Url
                    </label>} rules={[{ required: true, message: 'Please Enter Embed Url!' }]}>
                        <Input placeholder='Embed Url' className="select-theme-width" />
                    </Form.Item>
                    
                    <Form.Item name="powerBIToken" className='col pl-2' label={<label
                        className="form-control-label font12"
                    >
                        Token
                    </label>}>
                        <Input placeholder='Token' className="select-theme-width" />
                    </Form.Item>

                    <Form.Item name="powerBIId" className='col pl-2' label={<label
                        className="form-control-label font12"
                    >
                        Embed Id
                    </label>}>
                        <Input placeholder='Embed Id' className="select-theme-width" />
                    </Form.Item>
                </Row>
                        <Row>
                            <Col className='text-center'>
                                <Form.Item className='pl-2 save-btn-widgets  mb-0' >
                                    {/* <Button title='Cancel' type="ghost">
                                        Cancel
                                    </Button> */}
                                    <Button htmlType="submit" title='Save' className='ml-3'>
                                        <SaveOutlined className='df-text-ant-success'/> Save
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
            </Form>
        </CardBody>
    </Card>
        </Panel>
    </Collapse>
}
export default PowerBiRender;